// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ResearchCardCommonLayout} from 'app_components/commons/researchCard'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
import { IMediaData } from 'app_types/media/media.types'
// @end

// @ADD Component types
interface IResearchCardCommonProps {
  cover: string,
  title: string
  subtitle: string
  authors?: Array<string>
  media?: IMediaData
  list?: string
}
interface IResearchCardCommonState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ResearchCardCommon extends Component<IResearchCardCommonProps, IResearchCardCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IResearchCardCommonProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <ResearchCardCommonLayout
        {...this.props}
      />
    )
  }
}

export default connect(mapStatesToProps)(ResearchCardCommon)
